import { render, staticRenderFns } from "./JacketViewSwitcher.vue?vue&type=template&id=a12a43b4&scoped=true&"
import script from "./JacketViewSwitcher.vue?vue&type=script&lang=js&"
export * from "./JacketViewSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./JacketViewSwitcher.vue?vue&type=style&index=0&id=a12a43b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12a43b4",
  null
  
)

export default component.exports